import { render, staticRenderFns } from "./TechLevel.vue?vue&type=template&id=656ffd88&"
import script from "./TechLevel.vue?vue&type=script&lang=js&"
export * from "./TechLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports